
export const DEVICES = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  TABLET: 'tablet',
}

export const DESKTOP_GRID_SIZE = 'lg'
export const TABLET_HORIZONTAL_GRID_SIZE = 'md'
export const TABLET_VERTICAL_GRID_SIZE = 'sm'
export const MOBILE_GRID_SIZE = 'xs'